export default "__VITE_ASSET__WTNm34Gc__"